import { createFileRoute } from "@tanstack/react-router";
import { SupportPageContainer } from "@charphq/ui/components/layout/pages/SupportPageContainer";

export const Route = createFileRoute("/support")({
  component: SupportPageContainer,
});
